import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { EditStatoRiparazioneComponent } from './dialogs/edit/edit.component';
import { StatiRiparazioneComponent } from './stati-riparazione.component';



@NgModule({
  declarations: [StatiRiparazioneComponent,
    EditStatoRiparazioneComponent,],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
  ],
  exports: [StatiRiparazioneComponent,
    EditStatoRiparazioneComponent,]
})
export class StatiRiparazioneModule { }
